export default function initGoalSheet(el) {
  const overlay = el.querySelector('.sheet-overlay');
  const content = el.querySelector('.sheet-content');
  const closeBtn = el.querySelector('[data-action="close"]');
  const form = el.querySelector('form');
  const titleEl = document.getElementById('goal-sheet-title');
  const inputWeight = form.querySelector('input[name="goal_weight"]');
  const submitBtn = el.querySelector('[type="submit"]');
  
  const openBtns = document.querySelectorAll('[data-action="open-goal-sheet"]');

  const closeSheet = () => {
    overlay.classList.add('opacity-0');
    content.classList.add('translate-y-full');
    setTimeout(() => {
      el.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    }, 300);
  };

  const openSheet = (btn) => {
    const exId = btn.getAttribute('data-id');
    const name = btn.getAttribute('data-name');
    const weight = btn.getAttribute('data-weight');

    titleEl.textContent = name;
    inputWeight.value = weight || '';
    
    // Set dynamic form action
    form.action = `/api/v1/exercises/${exId}/goals`;
    
    el.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
    void el.offsetWidth; // trigger reflow
    overlay.classList.remove('opacity-0');
    content.classList.remove('translate-y-full');
  };

  openBtns.forEach(btn => btn.addEventListener('click', () => openSheet(btn)));
  if (closeBtn) closeBtn.addEventListener('click', closeSheet);
  if (overlay) overlay.addEventListener('click', closeSheet);

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const weight = Number(inputWeight.value);

    // Basic client validation to stop early
    if (isNaN(weight) || weight <= 0) {
      if (typeof submitBtn.stopLoading === 'function') submitBtn.stopLoading();
      return;
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ goal_weight: weight })
      });
      
      const data = await response.json();

      function showError(msg) {
        const contentEl = document.getElementById('error-modal-content');
        const triggerEl = document.getElementById('error-modal-trigger');
        if (contentEl && triggerEl) {
          contentEl.innerText = msg;
          triggerEl.click();
        }
      }
      
      if (response.ok) {
        window.location.reload(); // Simple reload to grab updated UI states from SSR
      } else {
        showError(data.error || "Ocurrió un error al guardar tu meta.");
        if (typeof submitBtn.stopLoading === 'function') submitBtn.stopLoading();
      }
    } catch (err) {
      showError("Error de conexión.");
      if (typeof submitBtn.stopLoading === 'function') submitBtn.stopLoading();
    }
  });
}
